import { useQuery } from "react-query";
import useApiFetch from "./useApiFetch";
import useClientContext from "./useClientContext";

/**
 * React Query hook to fetch an entry's leagues.
 * @example
 * import useMyLeagues from "@hooks/useMyLeagues";
 * ...
 * const { data: myLeagues } = useMyLeagues();
 * const leagueNumber = myLeagues.length
 */
export default function useMyLeagues() {
  const [{ currentEntry }] = useClientContext();
  const { fetchApiEndpoint } = useApiFetch();

  const entryId = currentEntry?.id || null;

  return useQuery<MyLeagues, Error>(
    ["my-leagues", entryId],
    () =>
      fetchApiEndpoint(`/api/v1/chase/leagues/mine.json`, {
        headers: { "content-type": "application/json" },
        method: "GET",
      }),
    {
      enabled: Boolean(entryId),
      retry: 2,
      cacheTime: null,
      refetchInterval: null,
      initialData: {
        leagues: [],
      },
    },
  );
}

export interface MyLeagues {
  leagues: MyLeague[];
}

export interface MyLeague {
  creator_id: number;
  id: number;
  is_private: boolean;
  memberships_count: number;
  motto: string;
  name: string;
  password: string;
  league_rank: number;
}
